// extracted by mini-css-extract-plugin
export default {"bigButton":"Button_bigButton__Kvg6p","title":"Button_title__9Qncg"};